<div class="page-wrapper">
  <div class="h-100" (isEnglish)="isEnglish = $event">
    <div class="d-flex flex-column justify-content-between h-100">
      <div class="row text-primary px-4">
        <div class="col-lg-4 col-md-6 col-sm-12 d-flex flex-column">
          <p>{{ "FIELDS.EMAIL" | translate }}</p>
          <p class="font-18 fw-bold">{{ invoiceData()?.email ?? "-" }}</p>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 d-flex flex-column">
          <p>{{ "FIELDS.PHONE" | translate }}</p>
          <p class="font-18 fw-bold">{{ invoiceData()?.phone ?? "-" }}</p>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 d-flex flex-column">
          <p>{{ "FIELDS.NAME" | translate }}</p>
          <p class="font-18 fw-bold">{{ invoiceData()?.name ?? "-" }}</p>
        </div>
      </div>
      <hr class="w-100 mt-1 mb-2" />
      <!-- products -->
      @if (invoiceData()?.orderItems.length) {
        <div class="col-12 mt-4">
          <div class="products px-4">
            <div class="border primary position-relative">
              <label class="title text-primary position-absolute">
                {{ "SERVICES.Products" | translate }}
              </label>

              <div class="content px-lg-4 py-lg-3 mt-2">
                <div class="px-1">
                  <div class="page-wrapper text-primary">
                    <div class="row font-18 fw-bold">
                      <div class="col-4">
                        <p>{{ "FIELDS.PRODUCT" | translate }}</p>
                      </div>
                      <div class="col-4">
                        <p>{{ "FIELDS.QUANTITY" | translate }}</p>
                      </div>
                      <div class="col-4">
                        <p>{{ "FIELDS.PRICE" | translate }}</p>
                      </div>
                    </div>
                    @for (item of invoiceData()?.orderItems; track $index) {
                      <div class="row mt-1">
                        <div class="col-4">
                          <p>{{ isEnglish ? item.nameEn : item.nameAr }}</p>
                        </div>
                        <div class="col-4">
                          <p>{{ item.quantity }}</p>
                        </div>
                        <div class="col-4">
                          <p>{{ constructAmount(item.price * item.quantity) }}</p>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      <hr class="w-100 mt-1 mb-2 mt-4" />
      <div class="d-flex justify-content-between w-100 text-primary px-4 font-20 fw-bold">
        <p>{{ "PRODUCTS.ALL_PRODUCTS" | translate }}</p>
        <p>{{ orderItems?.length }}</p>
      </div>
      <div class="d-flex justify-content-between w-100 text-primary px-4 font-20 fw-bold">
        <p>{{ "PRODUCTS.TOTAL" | translate }}</p>

        <!-- <p>{{ constructAmount(totalBeforeDiscount) }}</p> -->
        <span class="px-2 d-flex align-items-end gap-2">
          <span class="font-16 currency">{{ constructAmount(totalBeforeDiscount) }}</span>
          <em class="db-icon-omr font-26"></em>
        </span>
      </div>

      <div class="d-flex justify-content-between w-100 text-primary px-4 font-20 fw-bold">
        <p>{{ "PRODUCTS.DISCOUNT" | translate }}</p>

        <!-- <p>{{ constructAmount(totalDiscount) }}</p> -->
        <span class="px-2 d-flex align-items-end gap-2">
          <span class="font-16 currency">{{ constructAmount(totalDiscount) }}</span>
          <em class="db-icon-omr font-26"></em>
        </span>
      </div>

      <div class="d-flex justify-content-between w-100 text-primary px-4 font-20 fw-bold">
        <p>{{ "FIELDS.VAT" | translate }}</p>

        <!-- <p>{{ constructAmount(vat) }}</p> -->
        <span class="px-2 d-flex align-items-end gap-2">
          <span class="font-16 currency">{{ constructAmount(vat) }}</span>
          <em class="db-icon-omr font-26"></em>
        </span>
      </div>

      <div class="d-flex justify-content-between w-100 text-primary px-4 total font-20 fw-bold">
        <p>{{ "FIELDS.PRICE" | translate }}</p>

        <!-- <p>{{ constructAmount(totalAmount) }}</p> -->
        <span class="px-2 d-flex align-items-end gap-2">
          <span class="font-16 currency">{{ constructAmount(totalAmount) }}</span>
          <em class="db-icon-omr font-26"></em>
        </span>
      </div>

      <div class="not-printed payment">
        <div class="d-flex align-items-center flex-wrap gap-3 justify-content-end">
          @if (invoiceData()?.statusId === 3) {
            <app-button btnLabel="ACTIONS.PAY" btnClass="font-14 px-3 px-lg-4" color="primary" (onClick)="pay()" />
          }

          <!-- download -->
          <app-button btnLabel="ACTIONS.DOWNLOAD" btnClass="font-14 px-3 px-lg-4" color="primary" (onClick)="windowPrint()" />

          <!-- home -->
          <app-button btnLabel="HOME" btnClass="font-14 px-3 px-lg-4" color="primary" (onClick)="goHome()" />
        </div>
        @if (isFailedPayment) {
          <p class="text-danger fw-bold font-18 payment-failed text-center mt-3">{{ "ACTIONS.PAYMENT_FAILED" | translate }}</p>
        }
      </div>
    </div>
  </div>
</div>
